// Link da chamada da reunião: o Teams/Outlook grava em conference_url e o
// Google Meet em meet_link. Sem um dos dois, a reunião não tem sala online.
export function meetingJoinUrl(meeting) {
  if (!meeting) return null;
  const raw = meeting.join_url || meeting.conference_url || meeting.meet_link;
  if (!raw) return null;
  // Só link https vira botão: nada de javascript: ou outro esquema vindo do dado.
  try {
    return new URL(raw).protocol === "https:" ? raw : null;
  } catch (e) {
    return null;
  }
}

export function meetingJoinLabel(meeting) {
  if (!meetingJoinUrl(meeting)) return null;
  const provider =
    meeting.join_provider ||
    (meeting.conference_provider === "teams" ? "teams" : "meet");
  return provider === "teams" ? "Entrar no Teams" : "Entrar no Meet";
}
